module.exports = __webpack_public_path__ + "img/main_banner_01.4d307fe.webp";